module.exports = __webpack_public_path__ + "img/istp.254f9339.png";